import React from "react";
import "../styles/Loader.css";
import { Circles } from "react-loader-spinner";
function Loader() {
  return (
    <div className="loader">
      <Circles
        height="80"
        width="80"
        color="#2b2b93"
        ariaLabel="circles-loading"
        visible={true}
      />
    </div>
  );
}

export default Loader;
